// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.PatientSimpleSearchRequest */
/* istanbul ignore next */
@GandalfModel
export class PatientSimpleSearchRequest extends GandalfModelBase {

	@GandalfLabel('Search Criteria')
	@GandalfValidator({ notNull: { message: 'Search Criteria is required' } })
	@GandalfValidator({ sizeString: { fieldLabel: 'Search Criteria', maxLength: 1000, minLength: 2, message: 'Search Criteria must be between 2 and 1000 characters' } })
	@GandalfProperty({ designType: String, isRequired: true })
	queryString!: string;

}
